import { render, staticRenderFns } from "./ReviewProgress.vue?vue&type=template&id=015d4407&scoped=true&"
import script from "./ReviewProgress.vue?vue&type=script&lang=js&"
export * from "./ReviewProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015d4407",
  null
  
)

export default component.exports